import { call, put } from 'redux-saga/effects';
import { VehicleConfigurationAttributesService } from '../services';
import { getVehicleConfigurationAttributesSuccessAction, getVehicleConfigurationAttributesFailureAction } from '../actions';
export function* getVehicleConfigurationAttributesSaga(action, 
/*istanbul ignore next*/
vehicleConfigurationAttributesService = VehicleConfigurationAttributesService.getInstance()) {
    try {
        const attributesFromServer = yield call({
            context: vehicleConfigurationAttributesService,
            fn: vehicleConfigurationAttributesService.getVehicleConfigurationAttributes
        }, action.payload.vehicleId, action.payload.dateOfLoss);
        yield put(getVehicleConfigurationAttributesSuccessAction(vehicleConfigurationAttributesService.normalizeAttributesData(attributesFromServer)));
    }
    catch (exception) {
        yield put(getVehicleConfigurationAttributesFailureAction(exception.toString()));
    }
}
//# sourceMappingURL=getVehicleConfigurationAttributesSaga.js.map